// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"7281166e","141":"5a4f9621","236":"e02078b4","324":"de076d81","360":"e2f04cda","453":"6f63c8de","484":"2b72a5c2","578":"f4727948","666":"7784e0bc","682":"8f37ed1d","756":"6232384d","832":"7b84abef","888":"0968c71d"}[chunkId] + ".chunk.js";
};